import { init, captureException } from '@sentry/browser';
import { getEnv } from '../getEnv';

// エラー通知が必要な箇所でこのファイルを import する。
// initSentry で初期化、captureException でエラーを通知

const initSentry = () => {
  const env = getEnv();

  init({
    dsn: 'https://63314967ddd40bbb40bcda5550c0f4be@o4506572598149120.ingest.sentry.io/4506698316447744',
    defaultIntegrations: false,
    environment: env,
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: {
        request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
        response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      },
      httpBodies: [],
      urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      genAI: { inputs: false, outputs: false },
      databaseQueryData: false,
      graphQL: { document: false, variables: false },
    },
  });
};

export { initSentry, captureException };
